import { axiosGet, axiosPost } from "../../../react_axios/Axios";
import {
    headers, delegateRegistrationGroupNextSubmitUrl, delegateGroupRegistrationFinalSubmitUrl,
    getDelegatePreviewDetailsUrl, GET_DELEGATE_PREVIEW_DETAILS, DELEGATE_REGISTRATION_GROUP_FINAL_ACTION_TYPE,
    DELEGATE_REGISTRATION_GROUP_NEXT_ACTION_TYPE, getGroupDelegateDetailsStep1Url, getGroupDelegateDetailsUrl,
    GET_GROUP_DELEGATE_DETAILS, GET_GROUP_DELEGATE_DETAILS_STEP1, delegaterRegistrationNextSubmitUrl,
    delegateRegistrationFinalSubmitUrl, DELEGATE_REGISTRATION_FINAL_ACTION_TYPE, deleteVisaDocDelegateUrl,
    DELETE_VISA_DOC_DELEGATE, DELEGATE_REGISTRATION_NEXT_ACTION_TYPE, delegatePreviewSubmitUrl, DELEGATE_PREVIEW_SUBMIT,
    deleteDelegateUrl, DELETE_DELEGATE_ACTION_TYPE, getDelegateFieldListUrl, GET_DELEGATE_FIELD_LIST_ACTION_TYPE,
    GET_DELEGATE_DETAILS_UUID, getDelegateDetailsUUIDUrl, GET_DELEGATE_REGISTRATION_LIST, getDelegateRegistrationListUrl, delegateConfirmationUrl
} from "../../../utils/constants";


export const delegateRegistrationGroupNext_action = (GroupDetailsList, IsAgree) => async (dispatch) => {
    console.log(JSON.parse(sessionStorage.getItem('DelegateDataSS')), 'ldaaaata')
    try {
        const mapdata = {
            UserID: JSON.parse(sessionStorage.getItem('DelegateDataSS')) != null ? JSON.parse(sessionStorage.getItem('DelegateDataSS')).UserID : "",
            ExhibitionID: sessionStorage.getItem("sessionExhibitionID"),
            // CountryID: countryId,
            GroupDetailsList: GroupDetailsList,
            IsAgree: IsAgree
            // visitDaysList: list
        }
        console.log("visitorRegistrationNext_action--------->", mapdata)
        const res = await axiosPost(delegateRegistrationGroupNextSubmitUrl, mapdata, headers);
        dispatch({
            type: DELEGATE_REGISTRATION_GROUP_NEXT_ACTION_TYPE,
            payload: res,
        });
        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const delegateRegistrationGroupSubmit_action = (ISAgree) => async (dispatch) => {
    try {
        const mapdata = {
            UserID: ((JSON.parse(sessionStorage.getItem('DelegateDataSS')).UserIDs).split(','))[0],
            ExhibitionID: sessionStorage.getItem("sessionExhibitionID"),
            DelegateRegistrationIDs: JSON.parse(sessionStorage.getItem('DelegateDataSS')).DelegateRegistrationIDs,
            ISAgree: ISAgree,
        }
        const res = await axiosPost(delegateGroupRegistrationFinalSubmitUrl, mapdata, headers);
        dispatch({
            type: DELEGATE_REGISTRATION_GROUP_FINAL_ACTION_TYPE,
            payload: res,
        });

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const getDelegatePreviewDetails_action = (DelegateType) => async (dispatch) => {
    console.log("JSON.parse(sessionStorage.getItem('DelegateDataSS'))", JSON.parse(sessionStorage.getItem('DelegateDataSS')))
    try {
        const param = {
            UserId: DelegateType == 10 ? ((JSON.parse(sessionStorage.getItem('DelegateDataSS')).UserIDs).split(','))[0] : JSON.parse(sessionStorage.getItem('DelegateDataSS')).UserID,
            AccountID: DelegateType == 10 ? JSON.parse(sessionStorage.getItem('DelegateDataSS')).AccountIDs : JSON.parse(sessionStorage.getItem('DelegateDataSS')).AccountID,
            ExhibitionID: sessionStorage.getItem("sessionExhibitionID"),
            DelegateRegistrationID: DelegateType == 10 ? JSON.parse(sessionStorage.getItem('DelegateDataSS')).DelegateRegistrationIDs : JSON.parse(sessionStorage.getItem('DelegateDataSS')).DelegateRegistrationID
        }

        const res = await axiosGet(getDelegatePreviewDetailsUrl, param, headers);
        dispatch({
            type: GET_DELEGATE_PREVIEW_DETAILS,
            payload: res,
        });
        console.log("getVisitorPreviewDetails_action--------->", param)
        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const getDelegateDetails_action = (DelegateType) => async (dispatch) => {
    var VisitorTypeIDUserID = sessionStorage.getItem('DelegateTypeID') == 10 && ((JSON.parse(sessionStorage.getItem('DelegateDataSS')).UserIDs).split(','))[0]
    try {
        const param = {
            UserId: DelegateType == 10 ? ((JSON.parse(sessionStorage.getItem('DelegateDataSS')).UserIDs).split(','))[0] ?? '' : JSON.parse(sessionStorage.getItem('DelegateDataSS')).UserID ?? '',
            AccountID: DelegateType == 10 ? JSON.parse(sessionStorage.getItem('DelegateDataSS')).AccountIDs : JSON.parse(sessionStorage.getItem('DelegateDataSS')).AccountID,
            ExhibitionID: sessionStorage.getItem("sessionExhibitionID"),
            DelegateRegistrationID: DelegateType == 10 ? JSON.parse(sessionStorage.getItem('DelegateDataSS')).DelegateRegistrationIDs : JSON.parse(sessionStorage.getItem('DelegateDataSS')).DelegateRegistrationID
        }

        const res = await axiosGet(getGroupDelegateDetailsUrl, param, headers);
        dispatch({
            type: GET_GROUP_DELEGATE_DETAILS,
            payload: res,
        });
        console.log("getVisitorPreviewDetails_action--------->", param)
        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const getDelegateDetailsStep1_action = (DelegateType) => async (dispatch) => {
    var VisitorTypeIDUserID = sessionStorage.getItem('DelegateTypeID') == 10 && ((JSON.parse(sessionStorage.getItem('DelegateDataSS')).UserIDs).split(','))[0]
    try {
        const param = {
            UserId: DelegateType == 10 ? ((JSON.parse(sessionStorage.getItem('DelegateDataSS')).UserIDs).split(','))[0] : JSON.parse(sessionStorage.getItem('DelegateDataSS')).UserID,
            AccountID: DelegateType == 10 ? JSON.parse(sessionStorage.getItem('DelegateDataSS')).AccountIDs : JSON.parse(sessionStorage.getItem('DelegateDataSS')).AccountID,
            ExhibitionID: sessionStorage.getItem("sessionExhibitionID"),
            DelegateRegistrationID: DelegateType == 10 ? JSON.parse(sessionStorage.getItem('DelegateDataSS')).DelegateRegistrationIDs : JSON.parse(sessionStorage.getItem('DelegateDataSS')).DelegateRegistrationID
        }

        const res = await axiosGet(getGroupDelegateDetailsStep1Url, param, headers);
        dispatch({
            type: GET_GROUP_DELEGATE_DETAILS_STEP1,
            payload: res,
        });
        console.log("getVisitorPreviewDetails_action--------->", param)
        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const delegateRegistrationNext_action = (AccountID, DelegateRegistrationID, CountryID, AccountTypeID,
    PersonIncharge_Title, PersonIncharge_FirstName, PersonIncharge_LastName, PersonIncharge_GenderID,
    PersonIncharge_Designation, CompanyName, GSTNo, PanNo, IECCode, Address1, Address2, Address3, Website,
    MobileNo, WhatsappMobileNo, IsSameMobileNo, State, City, Pin, PrimaryEmail, Telephone, Telephone1,
    CompanyProfile, CompanyWebsite, TotalOperationalYears, CompanyTurnOverID, ArrivalDate, DepartureDate,
    IsCoordinator, isCoordinatorAsDelegate, PersonProfile, PersonPhoto, PersonPhotoName, PersonPhotoData, PersonPhotoType, IsAgree, ExhProgramList, ExhProgramDateList, ExhProgramCategory, Source) => async (dispatch) => {

        try {
            const mapdata = {
                UserID: (sessionStorage.getItem('DelegateDataSS')) != null ? JSON.parse(sessionStorage.getItem('DelegateDataSS')).UserID : "",
                AccountID: (sessionStorage.getItem('DelegateDataSS')) != null ? JSON.parse(sessionStorage.getItem('DelegateDataSS')).AccountID : "",
                DelegateRegistrationID: (sessionStorage.getItem('DelegateDataSS')) != null ? JSON.parse(sessionStorage.getItem('DelegateDataSS')).DelegateRegistrationID : "",
                ExhibitionID: sessionStorage.getItem("sessionExhibitionID"),
                CountryID: CountryID,
                AccountTypeID: AccountTypeID,
                PersonIncharge_Title: PersonIncharge_Title,
                PersonIncharge_FirstName: PersonIncharge_FirstName,
                PersonIncharge_LastName: PersonIncharge_LastName,
                PersonIncharge_GenderID: PersonIncharge_GenderID,
                PersonIncharge_Designation: PersonIncharge_Designation,
                CompanyName: CompanyName,
                GSTNo: GSTNo,
                PanNo: PanNo,
                IECCode: IECCode,
                Address1: Address1,
                Address2: Address2,
                Address3: Address3,
                Website: Website,
                MobileNo: MobileNo,
                WhatsappMobileNo: WhatsappMobileNo,
                IsSameMobileNo: IsSameMobileNo,
                State: State,
                City: City,
                Pin: Pin,
                PrimaryEmail: PrimaryEmail,
                Telephone: Telephone,
                Telephone1: Telephone1,
                CompanyProfile: CompanyProfile,
                CompanyWebsite: CompanyWebsite,
                TotalOperationalYears: TotalOperationalYears,
                CompanyTurnOverID: CompanyTurnOverID,
                ArrivalDate: ArrivalDate,
                DepartureDate: DepartureDate,
                IsCoordinator: IsCoordinator,
                isCoordinatorAsDelegate: isCoordinatorAsDelegate,
                PersonProfile: PersonProfile,
                PersonPhoto: PersonPhoto,
                PersonPhotoName: PersonPhotoName,
                PersonPhotoData: PersonPhotoData,
                PersonPhotoType: PersonPhotoType,
                IsAgree: IsAgree,
                ExhProgramList: ExhProgramList,
                ExhProgramDateList: ExhProgramDateList,
                ExhProgramCategory: ExhProgramCategory,
                Source: Source
            }
            const res = await axiosPost(delegaterRegistrationNextSubmitUrl, mapdata, headers);
            dispatch({
                type: DELEGATE_REGISTRATION_NEXT_ACTION_TYPE,
                payload: res,
            });
            return Promise.resolve(res);
        } catch (err) {
            return Promise.reject(err);
        }
    };

export const delegateRegistrationSubmit_action = (AccountID, DelegateRegistrationID, IsIntrestedForB2B, isVisaAssistance, NameOnPassport, ApplicantEmailID, ApplicantMobileNo, PassportNo, PassportIssueDate, PassportExpiryDate, PassportIssuingCountryID, PassportFilePath, PassportFile, PassportFileName, PassportFileType, industrySegmentMappingList, purposeofVisitList, daysList, interestSeminarList, hallChapterList, B2BMeetingList, ISAgree) => async (dispatch) => {
    console.log(JSON.parse(sessionStorage.getItem('DelegateDataSS')), 'ldaaaata')
    try {
        const mapdata = {
            UserID: (sessionStorage.getItem('DelegateDataSS')) != null ? JSON.parse(sessionStorage.getItem('DelegateDataSS')).UserID : "",
            AccountID: (sessionStorage.getItem('DelegateDataSS')) != null ? JSON.parse(sessionStorage.getItem('DelegateDataSS')).AccountID : "",
            DelegateRegistrationID: (sessionStorage.getItem('DelegateDataSS')) != null ? JSON.parse(sessionStorage.getItem('DelegateDataSS')).DelegateRegistrationID : "",
            DelegateRegistrationNo: (sessionStorage.getItem('DelegateDataSS')) != null ? JSON.parse(sessionStorage.getItem('DelegateDataSS')).DelegateRegistrationNo : "",
            ExhibitionID: sessionStorage.getItem("sessionExhibitionID"),

            IsIntrestedForB2B: IsIntrestedForB2B,
            isVisaAssistance: isVisaAssistance,
            NameOnPassport: NameOnPassport,
            ApplicantEmailID: ApplicantEmailID,
            ApplicantMobileNo: ApplicantMobileNo,
            PassportNo: PassportNo,
            PassportIssueDate: PassportIssueDate,
            PassportExpiryDate: PassportExpiryDate,
            PassportIssuingCountryID: PassportIssuingCountryID,
            PassportFilePath: PassportFile,
            PassportFile: PassportFile,
            PassportFileName: PassportFileName,
            PassportFileType: PassportFileType,

            industrySegmentMappingList: industrySegmentMappingList,
            purposeofVisitList: purposeofVisitList,
            daysList: daysList,
            interestSeminarList: interestSeminarList,
            hallChapterList: hallChapterList,
            B2BMeetingList: B2BMeetingList,
            ISAgree: ISAgree,

            // visitDaysList: list
        }
        console.log("visitorRegistrationNext_action--------->", mapdata)
        const res = await axiosPost(delegateRegistrationFinalSubmitUrl, mapdata, headers);
        dispatch({
            type: DELEGATE_REGISTRATION_FINAL_ACTION_TYPE,
            payload: res,
        });
        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const delegatePreviewSubmit_action = (DelegateType, AccountID, DelegateRegistrationID, totalCharges, isPaymentEnable, status, UUID) => async (dispatch) => {
    try {
        const delegateData = JSON.parse(sessionStorage.getItem('DelegateDataSS'));

        const isGroupDelegate = DelegateType == 10;

        const mapdata = {
            ExhibitionID: sessionStorage.getItem("sessionExhibitionID"),
            PayableCharges: totalCharges,
            isPaymentEnable: isPaymentEnable,
            UUID: UUID,
            Status: status,
            AccountId:
                AccountID
                    ? AccountID
                    : (isGroupDelegate
                        ? delegateData.AccountIDs
                        : delegateData.AccountID),

            DelegateRegistrationID:
                DelegateRegistrationID
                    ? DelegateRegistrationID
                    : (isGroupDelegate
                        ? delegateData.DelegateRegistrationIDs
                        : delegateData.DelegateRegistrationID)
        };
        const res = await axiosPost(delegatePreviewSubmitUrl, mapdata, headers);
        dispatch({
            type: DELEGATE_PREVIEW_SUBMIT,
            payload: res,
        });

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const deleteVisaDoc_action = (DelegateType, accountID, DelegateRegistrationID) => async (dispatch) => {

    try {
        const params = {
            UserID: DelegateType == 10 ? ((JSON.parse(sessionStorage.getItem('DelegateDataSS')).UserIDs).split(','))[0] : JSON.parse(sessionStorage.getItem('DelegateDataSS')).UserID,
            AccountID: DelegateType == 10 ? accountID : JSON.parse(sessionStorage.getItem('DelegateDataSS')).AccountID,
            DelegateRegistrationID: DelegateType == 10 ? DelegateRegistrationID : JSON.parse(sessionStorage.getItem('DelegateDataSS')).DelegateRegistrationID,
        }
        console.log("Delete deleteExhibitorBadge_ Document Action---------------->", params)
        const res = await axiosGet(deleteVisaDocDelegateUrl, params, headers)
        dispatch({
            type: DELETE_VISA_DOC_DELEGATE,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const deleteDelegate_action = (accountID, DelegateRegistrationID) => async (dispatch) => {

    try {
        const params = {
            UserID: ((JSON.parse(sessionStorage.getItem('DelegateDataSS')).UserIDs).split(','))[0],
            AccountID: accountID,
            DelegateRegistrationID: DelegateRegistrationID,
        }
        console.log("Delete deleteExhibitorBadge_ Document Action---------------->", params)
        const res = await axiosGet(deleteDelegateUrl, params, headers)
        dispatch({
            type: DELETE_DELEGATE_ACTION_TYPE,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const getDelegateFirldList_action = (DelegateType) => async (dispatch) => {
    // var VisitorTypeIDUserID = sessionStorage.getItem('DelegateTypeID') == 10 && ((JSON.parse(sessionStorage.getItem('DelegateDataSS')).UserIDs).split(','))[0]
    try {
        const delegateData = JSON.parse(sessionStorage.getItem('DelegateDataSS') || 'null');

        const userId = delegateData
            ? (DelegateType === 10
                ? delegateData.UserIDs?.split(',')[0] || ''
                : delegateData.UserID || '')
            : '';

        const param = {
            UserId: userId,
            ExhibitionID: sessionStorage.getItem("sessionExhibitionID"),
            AccountTypeID: DelegateType
        };

        const res = await axiosGet(getDelegateFieldListUrl, param, headers);
        dispatch({
            type: GET_DELEGATE_FIELD_LIST_ACTION_TYPE,
            payload: res,
        });
        console.log("getVisitorPreviewDetails_action--------->", param)
        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const delegateConfirmation_action = (regid) => async (dispatch) => {
    try {
        const param = {
            ExhibitionID: sessionStorage.getItem("sessionExhibitionID"),
            DelegateRegistrationID: regid,
        }

        const res = await axiosGet(delegateConfirmationUrl, param, headers);
        dispatch({
            type: GET_DELEGATE_DETAILS_UUID,
            payload: res,
        });
        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const getDelegateDetailsUUID_action = (UUID) => async (dispatch) => {
    try {
        const param = {
            UUID: UUID
        }

        const res = await axiosGet(getDelegateDetailsUUIDUrl, param, headers);
        dispatch({
            type: GET_DELEGATE_DETAILS_UUID,
            payload: res,
        });
        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const getDelegateRegistrationList_action = (ExhibitionID, DelegateRegistrationNo, CompanyName, PersonName, PrimaryEmail, CountryID, AccountTypeID, isConfirmed) => async (dispatch) => {
    try {
        const param = {
            UserID: JSON.parse(sessionStorage.getItem("loginDataSS")).UserID,
            ExhibitionID: ExhibitionID != '' ? ExhibitionID : sessionStorage.getItem("sessionExhibitionID"),
            DelegateRegistrationNo: DelegateRegistrationNo?.trim() != '' ? DelegateRegistrationNo : null,
            CompanyName: CompanyName?.trim() != '' ? CompanyName : null,
            PersonName: PersonName?.trim() != '' ? PersonName : null,
            PrimaryEmail: PrimaryEmail?.trim() != '' ? PrimaryEmail : null,
            CountryID: CountryID != '' ? CountryID : null,
            AccountTypeID: AccountTypeID != '' ? AccountTypeID : null,
            isConfirmed: isConfirmed != '' && isConfirmed != null ? isConfirmed : null
        }

        const res = await axiosGet(getDelegateRegistrationListUrl, param, headers);
        dispatch({
            type: GET_DELEGATE_REGISTRATION_LIST,
            payload: res,
        });
        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};